<template>
  <section>
    <v-card>
      <v-card-text>
        <v-layout>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              dark
              v-if="es_registro_ad"
              @click.native.stop="crearActualizarPersona({})"
              slot="activator"
              ><v-icon dark>add</v-icon> {{ $t("common.add") }}</v-btn
            >
            <span>Agregar Persona</span>
          </v-tooltip>
          <!-- Boton filtro -->
          <v-tooltip bottom>
            <v-btn
              @click.native="
                () => {
                  filterShow = filterShow ? false : true;
                }
              "
              class="btn-refresh"
              slot="activator"
              ><v-icon>filter_list</v-icon>
            </v-btn>
            <span>Búsqueda/filtros</span>
          </v-tooltip>
          <!-- Boton acutualizar -->
          <v-tooltip bottom>
            <v-btn
              @click.native="listaPersonas()"
              class="btn-refresh"
              slot="activator"
              ><v-icon>refresh</v-icon>
            </v-btn>
            <span>{{ $t("common.updateList") }}</span>
          </v-tooltip>
        </v-layout>

        <!-- Filtros-->
        <v-flex xs12>
          <transition name="slide-fade">
            <div class="filter-container-rrhh" v-show="filterShow">
              <v-icon small color="primary">search</v-icon>
              <div class="filter-item">
                <v-text-field
                  label="Apellido paterno"
                  v-model="form.ap_paterno"
                  @input="filterApPaterno"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Apellido materno"
                  v-model="form.ap_materno"
                  @input="filterApMaterno"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Nombres"
                  v-model="form.nombres"
                  @input="filterNombres"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Nro Documento"
                  v-model="form.nro_doc"
                  @input="filterNroDoc"
                ></v-text-field>
              </div>
              <!-- botones cerrar -->
              <div class="btn-filter">
                <v-tooltip bottom>
                  <v-btn icon small slot="activator" @click.native="recargar()">
                    <v-icon small>refresh</v-icon>
                  </v-btn>
                  <span>Recargar filtros</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    slot="activator"
                    @click.native="
                      () => {
                        filterShow = false;
                        recargar();
                      }
                    "
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                  <span>Cerrar filtros</span>
                </v-tooltip>
              </div>
            </div>
          </transition>
        </v-flex>
        <!-- :search="filters"
            :custom-filter="customFilter" -->
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          :headers="headers"
          :items="l_personas"
          no-data-text="Sin datos"
          no-results-text="No se encontro coincidencias"
          :rows-per-page-items="[10,25, 50, { text: 'Todo', value: -1 }]"
          item-key="index"
          :loading="loading"
          :pagination.sync="pagination"
          rows-per-page-text="Filas por pagina"
          :search="filters"
          :custom-filter="customFilter"
        >
          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <td class="text-xs-center py-0 px-1">
              <v-avatar
                :color="items.item.foto ? '#FFF' : 'light-blue darken-4'"
              >
                <img
                  v-if="items.item.foto"
                  :src="url_backend + items.item.foto"
                  :alt="items.item.nombres[0]"
                  style="border: 1px solid #7BAFD4 !important;"
                  @error="handleImageError(items.item)"
                />
                <span v-else class="white--text headline">{{
                  items.item.nombres[0] || "-"
                }}</span>
              </v-avatar>
            </td>
            <td class="text-xs-center">
              {{ items.item.ap_paterno }} {{ items.item.ap_materno }}
              {{ items.item.nombres }} {{ items.item.ap_casada }}
            </td>
            <td class="text-xs-center">
              {{ items.item.tipo_documento }}
            </td>
            <td class="text-xs-center">{{ items.item.nro_doc }}</td>
            <td class="text-xs-center">
              {{ items.item.correo ? items.item.correo : "-" }}
            </td>
            <td class="text-xs-center">{{ items.item.estado_persona }}</td>
            <td class="nowrap text-xs-center">
              <v-tooltip
                bottom
                v-if="items.item.id_estado === 1 && es_registro_ad == false"
              >
                <v-btn
                  v-if="es_visualizador_ad == false"
                  slot="activator"
                  color="green"
                  dark
                  icon
                  :to="`/personas/ficha-personal/${items.item.id}`"
                >
                  <v-icon>note</v-icon>
                </v-btn>
                <span>Ficha personal</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  v-if="es_registro_ad"
                  icon
                  slot="activator"
                  @click.native="crearActualizarPersona(items.item)"
                  color="primary"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <!-- <v-tooltip bottom>
                  <v-btn
                    v-if="esAdmin"
                    icon
                    slot="activator"
                    @click.native="deleteItem(items.item.id, 'persona')"
                    color="error"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <span>Eliminar registro</span>
                </v-tooltip> -->
              <v-tooltip bottom>
                <v-btn
                  v-if="
                    esAdmin &&
                      es_registro_ad == false &&
                      es_visualizador_ad == false
                  "
                  icon
                  slot="activator"
                  :to="`/movilidad/${items.item.id}`"
                  color="info"
                >
                  <v-icon>refresh</v-icon>
                </v-btn>
                <span>Movilidad</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import filtros from "../mixins/filtros";

export default {
  // Definición de componentes importados
  components: {},
  // Importación de métodos y funciones de un archivo mixin
  mixins: [filtros],
  props: {
    l_id_tipo_persona: {
      type: Array,
      default: null
    }
  },
  // Variables iniciales del componente
  data() {
    return {
      es_registro_ad: false,
      es_visualizador_ad: false,
      // Cabecera de la tabla
      headers: [
        { text: "", value: "", align: "center", sortable: false },
        { text: "Nombre completo", value: "nombre_completo", align: "center" },
        {
          text: "Tipo de documento",
          value: "id_tipo_documento",
          align: "center"
        },
        { text: "Número de documento", value: "nro_doc", align: "center" },
        { text: "Correo", sortable: false, align: "center" },
        { text: "Estado", value: "estado_persona", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      esAdmin: false,
      l_personas: [],
      loading: false,
      pagination: {
        sortBy: ""
      },
      filters: {
        ap_paterno: "",
        ap_materno: "",
        nombres: "",
        nro_doc: ""
      },
      form: {},
      filterShow: true,
      url_backend: process.env.API_URL.split("api/")[0]
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    this.isAdmin();
    await this.listaPersonas();
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }

    this.$bus.$on("closeDialog", async () => {
      await this.listaPersonas();
    });
  },
  // Métodos y funciones del componente
  methods: {
    handleImageError(item) {
      item.foto = "";
    },
    // Metodo para ordenar la tabla
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    // Metodo para cargar listado de personas
    async listaPersonas() {
      this.loading = true;
      try {
        let rpta = await this.$service.graphql({
          query: `
              query{
                vPersonaUsuarios(id_estado_persona:1,l_tipo_persona:${JSON.stringify(
                  this.l_id_tipo_persona
                )}){
                  rows{
                      id:id_persona
                      nombres
                      ap_paterno
                      ap_materno
                      ap_casada
                      id_tipo_documento
                      nro_doc
                      nro_complemento
                      expedido
                      id_parametro_sexo
                      _user_created
                      _user_updated
                      _created_at
                      _updated_at
                      id_estado:id_estado_persona
                      estado_persona
                      tipo_documento
                      nombre_usuario
                      correo
                      id_usuario
                      foto
                  }
                }
              }
            `
        });
        rpta.vPersonaUsuarios.rows.forEach(element => {
          element.nombre_completo = `${element.ap_paterno} ${element.ap_materno} ${element.nombres}`;
        });
        this.l_personas = rpta.vPersonaUsuarios.rows;
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
    crearActualizarPersona(item) {
      // Adicionamos datos del tipo de persona
      item.tipo_persona = this.l_id_tipo_persona;
      this.$bus.$emit("openDialogCrearActualizarPersona", item);
    },
    isAdmin() {
      const user = this.$storage.get("user");
      const roles = user.roles;
      for (const i in roles) {
        if (
          roles[i].id == 32 ||
          roles[i].id == 107 ||
          roles[i].id == 115 ||
          roles[i].id == 118
        ) {
          this.esAdmin = true;
        }
        if (roles[i].id == 118) {
          this.es_registro_ad = true;
        }
        if (roles[i].id == 107) {
          this.es_visualizador_ad = true;
        }
      }
    },
    getPersonaId() {
      const user = this.$storage.get("user");
      let id_persona = user.id_persona;
      const roles = user.roles;
      for (const i in roles) {
        if (
          roles[i].id == 32 ||
          roles[i].id == 107 ||
          roles[i].id == 115 ||
          roles[i].id == 118
        ) {
          id_persona = 0;
        }
      }
      return id_persona;
    }
  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/persona/components/ListadoPersona.vue